import { LoginUrlsWrapper } from '../../app/spaces/Login/LoginUrls';
import { Module } from '../Module';
import {
  GeneratePasswordResetTokenRequest,
  IGeneratePasswordResetTokenParams,
} from '../ServerApi/requests/GeneratePasswordResetTokenRequest';
import { ServerService } from '../services/ServerService';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';

export interface IRequestPasswordResetScope extends ng.IScope {
  requestPasswordResetForm: any;
  username: string;
  initialized: boolean;
  errorMessages: string[];
  requestPasswordReset: () => void;
  restartPasswordReset: () => void;
}

export class RequestPasswordResetCtrl {

  public static $inject = [
    '$scope',
    'ServerService',
    '$translate'
  ];

  constructor($scope: IRequestPasswordResetScope,
              server: ServerService,
              $translate: ng.translate.ITranslateService) {
    if (!ServerSettingsUnauthenticated.isPasswordResetEnabled()) {
      LoginUrlsWrapper.navigateToSignIn({});
    }
    $scope.initialized = true;

    $scope.requestPasswordReset = () => {
      if ($scope.requestPasswordResetForm.$valid) {
        const requestParams: IGeneratePasswordResetTokenParams = {
          username: $scope.username
        };
        const passwordResetRequest = new GeneratePasswordResetTokenRequest(requestParams);
        server.sendRequest(passwordResetRequest);
        $scope.initialized = false;
      } else if ($scope.requestPasswordResetForm.$error.required) {
        if (!$scope.username) {
          $scope.errorMessages = [$translate.instant('enterYourUsername')];
          angular.element('input[name="username"]').focus();
        }
      }
    };

    $scope.restartPasswordReset = () => {
      $scope.username = '';
      $scope.initialized = true;
    };
  }
}

Module.instance().controller('RequestPasswordResetCtrl', RequestPasswordResetCtrl);

